import {MutationTree} from "vuex";
import {NavigationWidgetState} from "@/apps/NavigationWidget/model/navigation-widget-state";
import {Breakpoint} from "@/shared/models/breakpoint-type";
import INavigationItem from "@/apps/NavigationWidget/model/navigation-item";

export default <MutationTree<NavigationWidgetState>>{
    setLabels(state, labels: any) {
        state.labels = labels;
    },
    
    setCurrentBreakpoint(state, breakpoint: Breakpoint) {
        state.currentBreakpoint = breakpoint;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    },

    setMenuOpen(state, value: boolean) {
        state.menuOpen = value;
    },

    setStoredTree(state, storedTree: INavigationItem[]) {
        state.storedTree = storedTree;
    },

    pushStoredTreeItem(state, item: INavigationItem) {
        state.storedTree.push(item);
    },

    popStoredTreeItem(state) {
        state.storedTree.pop();
    },

    addBodyEleClass(state, value: string) {
        state.bodyEle.classList.add(value);
    },

    removeBodyEleClass(state, value: string) {
        state.bodyEle.classList.remove(value);
    },

    setData(state, json: any) {
        state.data = json;
    }
}



